import { render } from "./SubscriptionConfirmation.vue?vue&type=template&id=2742e75e&scoped=true"
import script from "./SubscriptionConfirmation.vue?vue&type=script&lang=js"
export * from "./SubscriptionConfirmation.vue?vue&type=script&lang=js"

import "./SubscriptionConfirmation.vue?vue&type=style&index=0&id=2742e75e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2742e75e"

export default script